<template>
  <div class="analytics-skeleton">
    <div class="card card-detail-layout mb-3">
      <div class="card-body">
        <div class="skeleton-line skeleton-title"></div>
        <div class="skeleton-line skeleton-subtitle"></div>
      </div>
    </div>
    <div class="row g-3 mb-3">
      <div v-for="n in 12" :key="n" class="col-12 col-sm-6 col-xl-3">
        <div class="card card-detail-layout h-100">
          <div class="card-body">
            <div class="skeleton-line skeleton-title"></div>
            <div class="skeleton-line skeleton-value"></div>
            <div class="skeleton-line skeleton-subtitle"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="row g-3">
      <div v-for="n in 4" :key="n" class="col-12 col-xl-6">
        <div class="card card-detail-layout">
          <div class="card-body">
            <div class="skeleton-line skeleton-title"></div>
            <div class="skeleton-block"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.skeleton-line,
.skeleton-block {
  background: linear-gradient(90deg, #edf2f7 25%, #f7fafc 37%, #edf2f7 63%);
  background-size: 400% 100%;
  animation: shimmer 1.2s ease-in-out infinite;
  border-radius: 10px;
}
.skeleton-line { height: 14px; margin-bottom: 10px; }
.skeleton-title { width: 40%; }
.skeleton-value { width: 30%; height: 28px; }
.skeleton-subtitle { width: 60%; }
.skeleton-block { min-height: 260px; }
@keyframes shimmer { 0% { background-position: 100% 0; } 100% { background-position: 0 0; } }
</style>
